import React from 'react';
import CarrierAccount from '../components/Carrier/carrier-account/carrier-account';

const Jobs = () => {
  return <CarrierAccount />;
};
export default Jobs;
